import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import useSubjectsContext from './context';
import ClippedImage from '~/components/clipped-image/clipped-image';
import './hero.scss';
const linesUrl = '/dist/images/subjects/graphic-lines.svg';
const waveUrl = '/dist/images/subjects/wave-bg.png';
export default function Hero() {
    const { heading, description, headingImage } = useSubjectsContext();
    return (React.createElement("section", { className: "hero" },
        React.createElement("div", { className: "background-images" },
            React.createElement("img", { className: "bg2", role: "presentation", src: waveUrl }),
            React.createElement("img", { className: "bg1", role: "presentation", src: linesUrl })),
        React.createElement(ClippedImage, { className: "overlapping", src: headingImage.meta.downloadUrl, alt: "" }),
        React.createElement("div", { className: "content" },
            React.createElement("h1", null, heading),
            React.createElement(RawHTML, { className: "text-content", html: description }))));
}
